import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { listar_obj, salvar_obj } from '../../../../../DinamicForms/actions'

import { withRouter } from 'react-router-dom';
import { withContainerCrud } from '../../../../../../../components/Utils';

const mapStateToProps = ({ DinamicCustomFormsReducer }, props) => {


    let uidCustomForm = props.customFormUid;

    const controler = DinamicCustomFormsReducer.rLista;

    let listaForms = controler.lista;
    let customForm = null;
    listaForms.forEach(f => {
        if (f.uid === uidCustomForm) {
            customForm = f;
        }
    });


    let propTipo = props.fluxo

    let chaveReducer = uidCustomForm;
    let loading = true;
    let lista = [];

    if (customForm.chaveSalvar) {
        chaveReducer = customForm.chaveSalvar
    }
    if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
        loading = DinamicCustomFormsReducer.rListaObj[chaveReducer].loading;
        lista = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
    }

    let listaItens = [];
    if (lista) {
        try {
            listaItens = lista.slice()
        } catch (error) {
        }
    }

    if (props.someteComValor) {
        listaItens = listaItens.filter(item => item[propTipo])
    }


    let listaTipos = [".", "Teste", "Teste2"]
    let propOrdem = "ordem" + propTipo
    let propOrdemAux = "";
    if (props.propOrdemAux) {
        propOrdemAux = props.propOrdemAux
    }





    if (customForm && customForm.componenteRoot) {
        let component = getComponente(customForm.componenteRoot, propTipo);


        if (component && component.opcoes) {
            if (!props.someteComValor) {
                listaTipos = ["."]
            } else {
                listaTipos = []
            }
            listaTipos = listaTipos.concat(component.opcoes)
        }
    }
    removeItem(listaTipos, "Arquivado")
    removeItem(listaTipos, "Cancelado")

    return {
        form: "FormFluxo" + customForm.nomeForm + props.titulo
        , uidCustomForm, customForm, propTipo, propOrdem, propOrdemAux, listaItens, listaTipos, loading, propsForm: { titulo: props.titulo }
    };
};
function removeItem(array, item) {
    var index = array.indexOf(item)
    if (index > -1) {
        array.splice(index, 1);
    }
}

export default compose(
    withRouter,
    connect(mapStateToProps, { listar: listar_obj, salvarItem: salvar_obj }),
    reduxForm(),
    withContainerCrud({}),

);

function getComponente(pai, field) {

    if (pai.field === field) {
        return pai;
    } else {
        if (pai.componentes) {
            for (let f in pai.componentes) {
                let r = getComponente(pai.componentes[f], field);
                if (r) {
                    return r;
                }
            }
        }
    }
    return null
}


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/components/ViewFluxoKamban/ViewFluxoKamban.enhancer.js